import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import * as Util from "../Utils/Util";
import Hider from "../Utils/Hider";
import ProductState from "./ProductState";

export default class SubscriptionToggle {
  private readonly element: HTMLElement;
  private readonly productCode: string;
  private readonly strengthCode: string;

  public constructor(element: HTMLElement) {
    this.element = element;

    this.productCode = Util.getData(element, "productCode");
    this.strengthCode = Util.getData(element, "strengthCode");

    Events.on("product-state-change", (s: ProductState) => this.handleChangedState(s));
  }

  private shouldShow(state: ProductState): boolean {
    return this.productCode == state.product.code && this.strengthCode == state.strength.code;
  }

  private handleChangedState(state: ProductState) {
    const shouldShow = this.shouldShow(state);
    Hider.match(this.element, shouldShow);
  }

  public static Factory: DomFactory<SubscriptionToggle> = (e) => new SubscriptionToggle(e);
}
